<script setup lang="ts">
import type { NuxtError } from "#app";
import * as Sentry from "@sentry/browser";

const props = defineProps({
  error: Object as () => NuxtError,
});

onMounted(() => {
  try {
    Sentry.captureException(props.error);
  } catch (e) {
    console.error("Failed to capture error with Sentry", e);
  }
});
</script>

<template>
  <div>
    <UContainer>
      <UMain>
        <UPage>
          <UPageError
            :status="error?.statusCode"
            name="Auda"
            :message="`Noe gikk dessverre galt. Vennligst prøv igjen, eller kontakt support dersom problemet vedvarer. Feilmelding: ${error?.message}`"
            :clearButton="{ label: 'Gå til forsiden' }"
          />
        </UPage>
      </UMain>
    </UContainer>
  </div>
</template>
